export enum TimesEnum {
  NO = 'NO',
  DAILY = 'DAILY',
  TWO_TIMES_A_WEEK = '2 TIMES A WEEK',
  THREE_OR_MORE_TIMES_A_WEEK = '3 OR MORE TIMES A WEEK'
}
